import React from 'react';
import { Link } from 'react-router-dom';

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Breadcrumb */}
        <nav className="flex mb-8" aria-label="Breadcrumb">
          <ol className="flex items-center space-x-4">
            <li>
              <Link to="/" className="text-gray-400 hover:text-gray-500">
                Accueil
              </Link>
            </li>
            <li>
              <svg className="flex-shrink-0 h-5 w-5 text-gray-300" fill="currentColor" viewBox="0 0 20 20">
                <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
              </svg>
            </li>
            <li>
              <span className="text-gray-700 font-medium">Mentions légales</span>
            </li>
          </ol>
        </nav>

        {/* Header */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Mentions légales</h1>
          <p className="text-gray-600">
            Informations légales concernant le site www.ecoclima.energy
          </p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-lg p-8 space-y-8">
          
          {/* Article 1 - Éditeur du site */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Article 1 : Éditeur du site</h2>
            <div className="prose prose-gray max-w-none">
              <p className="mb-4">
                Le site web <strong>www.ecoclima.energy</strong> est édité par :
              </p>
              <div className="bg-blue-50 p-4 rounded-lg">
                <h3 className="font-semibold text-gray-900 mb-2">ECOCLIMA SARL</h3>
                <ul className="space-y-1 text-gray-700">
                  <li><strong>Capital social :</strong> 1 000 €</li>
                  <li><strong>Siège social :</strong> 15 Lotissement Les Cannelles Convenance, 97122 Baie-Mahault</li>
                  <li><strong>Numéro RCS :</strong> 983 802 018</li>
                  <li><strong>Date d'immatriculation :</strong> 24 janvier 2024</li>
                  <li><strong>Activités principales :</strong> Conseil en économie d'énergie – Installation d'appareillage électrique</li>
                  <li><strong>Gérants :</strong> Serge Gilles COQUILLAS et Stéphane Louis-Philippe MIATH</li>
                </ul>
              </div>
              <div className="mt-4 bg-green-50 p-4 rounded-lg">
                <h3 className="font-semibold text-gray-900 mb-2">Coordonnées</h3>
                <ul className="space-y-1 text-gray-700">
                  <li><strong>Email :</strong> <a href="mailto:contact@ecoclima.energy" className="text-blue-600 hover:text-blue-800">contact@ecoclima.energy</a></li>
                  <li><strong>Téléphone :</strong> <a href="tel:+590590197070" className="text-blue-600 hover:text-blue-800">0590 19 70 70</a></li>
                </ul>
              </div>
            </div>
          </section>

          {/* Article 2 - Responsable de la publication */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Article 2 : Responsable de la publication</h2>
            <p className="text-gray-700">
              Le responsable de la publication du site www.ecoclima.energy est <strong>M. Stéphane MIATH</strong>, gérant de la société ECOCLIMA SARL.
            </p>
          </section>

          {/* Article 3 - Hébergeur */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Article 3 : Hébergeur</h2>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-gray-700 mb-2">
                Le site www.ecoclima.energy est hébergé par :
              </p>
              <p className="font-semibold text-gray-900">OVH SAS</p>
              <p className="text-gray-700">Site web : <a href="https://www.ovh.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800">www.ovh.com</a></p>
            </div>
          </section>

          {/* Article 4 - Propriété intellectuelle */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Article 4 : Propriété intellectuelle</h2>
            <div className="prose prose-gray max-w-none">
              <p className="text-gray-700 mb-4">
                Tous les éléments du site <strong>www.ecoclima.energy</strong> sont la propriété exclusive d'ECOCLIMA, sauf mention contraire.
              </p>
              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
                <p className="text-gray-700">
                  <strong>Protection :</strong> Toute reproduction, distribution, modification, adaptation, retransmission ou publication de ces éléments est strictement interdite sans l'autorisation écrite expresse d'ECOCLIMA.
                </p>
              </div>
            </div>
          </section>

          {/* Article 5 - Responsabilité */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Article 5 : Responsabilité</h2>
            <div className="prose prose-gray max-w-none">
              <p className="text-gray-700 mb-4">
                La responsabilité d'ECOCLIMA est limitée concernant :
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Les omissions et inexactitudes pouvant figurer sur le site</li>
                <li>Les interruptions de service du site web</li>
                <li>Les dommages matériels ou immatériels résultant de l'utilisation du site</li>
                <li>L'accès à des sites externes via des liens hypertextes</li>
              </ul>
            </div>
          </section>

          {/* Article 6 - Données personnelles */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Article 6 : Données personnelles</h2>
            <div className="prose prose-gray max-w-none">
              <p className="text-gray-700 mb-4">
                ECOCLIMA traite les données personnelles conformément au <strong>Règlement Général sur la Protection des Données (RGPD)</strong>.
              </p>
              <div className="bg-blue-50 p-4 rounded-lg">
                <h3 className="font-semibold text-gray-900 mb-2">Vos droits</h3>
                <p className="text-gray-700 mb-2">Vous disposez des droits suivants :</p>
                <ul className="list-disc list-inside text-gray-700 space-y-1">
                  <li>Droit d'accès</li>
                  <li>Droit de rectification</li>
                  <li>Droit d'opposition</li>
                  <li>Droit à l'effacement</li>
                  <li>Droit à la portabilité</li>
                </ul>
                <p className="text-gray-700 mt-3">
                  Pour plus d'informations, consultez notre <Link to="/politique-confidentialite" className="text-blue-600 hover:text-blue-800 font-medium">Politique de confidentialité</Link>.
                </p>
              </div>
            </div>
          </section>

          {/* Article 7 - Droit applicable */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Article 7 : Droit applicable</h2>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-gray-700 mb-2">
                Les présentes mentions légales sont régies par le <strong>droit français</strong>.
              </p>
              <p className="text-gray-700">
                En cas de litige, les <strong>tribunaux de Pointe-à-Pitre</strong> sont seuls compétents.
              </p>
            </div>
          </section>

          {/* Contact */}
          <section className="border-t pt-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Contact</h2>
            <div className="bg-green-50 p-6 rounded-lg">
              <p className="text-gray-700 mb-4">
                Pour toute question concernant ces mentions légales, vous pouvez nous contacter :
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a
                  href="mailto:contact@ecoclima.energy"
                  className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                >
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  contact@ecoclima.energy
                </a>
                <a
                  href="tel:+590590197070"
                  className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                >
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  0590 19 70 70
                </a>
              </div>
            </div>
          </section>

        </div>
        
        {/* Navigation links */}
        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
          <Link 
            to="/politique-confidentialite" 
            className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-center"
          >
            Politique de confidentialité
          </Link>
          <Link 
            to="/cgv" 
            className="px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors text-center"
          >
            Conditions générales de vente
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegales;